// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource';
import Api from './common/ApiFactory.js'
import Functions from './common/functions.js'
import Filters from './common/filters.js'
import Dao from './common/dao/dao.js'




require('./assets/page.css')
require('./assets/modal.css')

// require('./assets/animate.css')
// require('./assets/iconfont/iconfont.css')





Vue.config.productionTip = false

Vue.prototype.Api = Api;

var dao = new Dao.Dao('cnPcEbookingDao');
Vue.prototype.dao = dao;
Vue.use(VueResource);
Vue.use(Functions);
Vue.use(Filters);


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js